export default __webpack_public_path__ + "static/media/8.b65e2997.jpg";